

export const URL = {
  Home: "/",
  Login: "/login",
  GetStarted: "/get-started",
  ForgotPassword: "/forgot-password",
  ResetPassword: "/reset",
  SignUp: "/sign-up",
  Email_Verified: "/email-verified",
  Dashboard: "/dashboard",
  Onboarding: "onboarding",

  //Vendors
  Vendors: "vendors",
  Vendors_Onboarding: "onboarding",
  Vendors_Management: "management",
  Vendors_Approval: "approval",
  Add_Vendor: "add-vendor",
  Create_Vendor: "create-vendor",
  View_Vendor: "view-vendor",
  All_Requisition: "Requisition",
  All_Quotation: "Quotation",

  //Procurement
  Procurement: "procurement",
  Requisition_Management: "requisition",
  Quotation_Management: "quotation",
  Delivery: "delivery",

  //Assets Routes
  Assets: "assets",
  Acquisition: "Acquisition",
  Add_Acquitions: "Add-Acquisition",
  View_Acquisition: "View-Acquisition",
  Requisition: "Requisition",
  Allocation: "Allocation",
  Monitoring: "Monitoring",
  Auctioning: "Auctioning",
  AuctionBidding: "Auctioning-Bidding",
  Report: "Report",
  Asset_Management: "Asset-Management",
  Asset_Configuration: "Asset-Configuration",

  //Fleets Routes
  Fleets: "fleets",
  Fleet_Management: "fleet-mgt",
  All_fleet:"All-Fleet",
  //Requisition:"Requisition",
  Add_Requisitions: "Add-Requisition",
  View_Requisitions: "view-requisition",
  My_Requisitions:"my-requisition",
  Fuel_Payment: "fuel-payment",
  My_Payment:"my-payment",

  Driver_Activity: "driver-activity",
  Add_Activity:"add-activity",
  Scheduler:"Scheduler",
  All_DriverActivity:"all-activity",
  Vehicle_Maintenance: "Vehicle-Maintenance",
  Accident_Report: "Accident-Report",
  Driver_Activities: "Driver-Activities",
  Vehicle_Document: "Vehicle-Document",
  Vehicle_Document_SetUp: "Vehicle-Document-SetUp",
 

  // Reports
  Reports: "reports",
  Generate_Report: "generate-report",
  Report_configuration: "report-configuration",
  Report_scheduler: "report-scheduler",
  Trigger_History: "trigger-history",


  Inventory: "inventory",
  //HR Routes
  HR: "hr",
  Leave_SetUp:"Leave-SetUp",
  Leave_Main:"Leave-Main",
  Leave_Approval:'Leave-Approval',
  Leave_HOD:'Leave-HOD',
  Training_SetUp: "Training-SetUp",
  Training_Request: "Training-Request",
  Exit_Discussion_SetUp:"Exit-Discussion-SetUp",
  Overtime_Setup:"Overtime-Setup",
  Overtime_Management:"Overtime-Management",
  Exit_Management:"Exit-Management",
  Query_SetUp:"Query-SetUp",
  Query_Management:"Query-Management",
  Add_Panel:"add-panel",
  All_Query_Management:"All-query-management",
  Employee_Management:"Employee-Management",
  NOK_Information: "NOK-Information",
  Add_NOK:"Add-NOK",
  Medical_Requisition:"Medical-Requisition",
  Add_Medical:"Add-Medical",
  Employee_Qualifications:'Employee-Qualifications',
  Employee_Claims:'Employee-Claims',
  Employee_Referees:'Employee-Referee',



  //Employee Routes
  Employee: "employee",
  Training: "training",
  Leave_Requisition:"Leave-Request",
  Add_Leave:"Add-Leave",
  View_Leave:"view-leave",
  leave_Recall:'Leave-Recall',
  Exit_Requisition:'Exit-Requisition',
  Exit_HOD:'Exit_HOD',
  Exit_Discussion:'Exit-Discussion',
  Overtime_Requisition:'Overtime_Requisition',
  Query:'Query',
  Query_By_HOD:'Query-By-HOD',
  Query_By_HOC:'Query-By-HOC',
  My_Query:'My-Query',
  Query_Response:"Query-Response",
  My_Query_Response: "My-Query-Response",
  My_Employee_Info:"My-Employee-Info",
  Add_My_NOK:"Add-My-NOK",
  My_NOK_Information:"My-NOK-Info",
  My_Medical_Requisition:"My-Medical-Requisition",
  Add_My_Medical:"Add-My-Medical",
  Add_Employee_Qualification:'Add-Qualification',
  Employee_Qualification:'Employee-Qualification',
  Employee_Refs:'Employee-Refs',
  Add_Employee_Referee:'Add-Employee-Referee',
  Add_Employee_Claim:'Add-claim',
  Employee_Extended_Claim:'Employee-Claim',
  





  Relationship: "relationship",

  // settings
  Settings: "settings",
  Permissions: "permissions",
  Permission_Group: "permissions-group",
  Grant_Permission: "grant-permission",
  Create_Staff: "create-staff",
  Edit_Staff: "edit-staff",
  Edit_Staff_Permissions: "edit-staff-permissions",

  //Consumable
  Consumables: "Consumables",
  Consumable_Acqusition: "acq",
  Consumable_Allocation: "all",
  Consumable_Requsition: "req",

  //Asset Set Up
  AssetSetUp: "Asset-Setup",
  AssetRegister: "AssetRegister",
  Categories: "Categories",
  Budget: "Budget",

  //sTORE & iNVENOTRU
  ConsummableSetUp: "Consummable-Setup",
  ConsummbaleRegister: "ConsummableRegister",
  ConsummableCategories: "Categories",
};